"use client";

import { c as _c } from "react/compiler-runtime";
import NextImage from "next/image";
import * as React from "react";
import type { Swiper as SwiperType } from "swiper";
import { FreeMode, Navigation, Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import ChevronLeftCarousel from "@/assets/images/common/chevron-left-carousel.png";
import { cn } from "@/lib/utils";

// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/free-mode";
interface ResponsiveCarouselProps {
  children: React.ReactNode[];
  className?: string;
  itemClassName?: string;
  desktopItemsPerView?: number; // Desktop items per row
  mobileItemsPerView?: number; // Mobile items per row (including half item)
  showArrows?: boolean; // Whether to show navigation arrows
  navigationTheme?: "light" | "dark" | "transparent"; // Navigation theme
  navigationSize?: "sm" | "md" | "lg"; // Navigation size
  navigationPosition?: "inside" | "outside"; // Navigation position
}
export function ResponsiveCarousel(t0) {
  const $ = _c(28);
  const {
    children,
    className,
    itemClassName,
    desktopItemsPerView: t1,
    mobileItemsPerView: t2,
    showArrows: t3,
    navigationTheme: t4,
    navigationSize: t5
  } = t0;
  const desktopItemsPerView = t1 === undefined ? 4 : t1;
  const mobileItemsPerView = t2 === undefined ? 2.5 : t2;
  const showArrows = t3 === undefined ? true : t3;
  const navigationTheme = t4 === undefined ? "transparent" : t4;
  const navigationSize = t5 === undefined ? "md" : t5;
  const swiperRef = React.useRef(null);
  let t6;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = () => {
      swiperRef.current?.slidePrev();
    };
    $[0] = t6;
  } else {
    t6 = $[0];
  }
  const handlePrevClick = t6;
  let t7;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = () => {
      swiperRef.current?.slideNext();
    };
    $[1] = t7;
  } else {
    t7 = $[1];
  }
  const handleNextClick = t7;
  let t8;
  if ($[2] !== children || $[3] !== className || $[4] !== desktopItemsPerView || $[5] !== itemClassName || $[6] !== mobileItemsPerView || $[7] !== navigationSize || $[8] !== navigationTheme || $[9] !== showArrows) {
    const buttonSizeClasses = {
      sm: "w-8 h-8",
      md: "w-10 h-10",
      lg: "w-12 h-12"
    };
    const buttonThemeClasses = {
      light: "bg-white shadow-md  text-gray-700 hover:bg-gray-50",
      dark: "bg-gray-800 text-white  hover:bg-gray-700",
      transparent: "  "
    };
    let t9;
    if ($[11] !== className) {
      t9 = cn("relative", className);
      $[11] = className;
      $[12] = t9;
    } else {
      t9 = $[12];
    }
    let t10;
    if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
      t10 = [Navigation, Pagination, FreeMode];
      $[13] = t10;
    } else {
      t10 = $[13];
    }
    let t11;
    let t12;
    if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
      t11 = {
        enabled: true,
        momentum: true,
        momentumRatio: 1,
        momentumVelocityRatio: 1
      };
      t12 = swiper => {
        swiperRef.current = swiper;
      };
      $[14] = t11;
      $[15] = t12;
    } else {
      t11 = $[14];
      t12 = $[15];
    }
    let t13;
    if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
      t13 = {
        enabled: false
      };
      $[16] = t13;
    } else {
      t13 = $[16];
    }
    let t14;
    if ($[17] !== desktopItemsPerView) {
      t14 = {
        768: {
          slidesPerView: desktopItemsPerView,
          spaceBetween: 10,
          freeMode: t13
        }
      };
      $[17] = desktopItemsPerView;
      $[18] = t14;
    } else {
      t14 = $[18];
    }
    let t15;
    if ($[19] !== children || $[20] !== itemClassName) {
      let t16;
      if ($[22] !== itemClassName) {
        t16 = (child, index) => <SwiperSlide key={index} className={cn("", itemClassName)}>{child}</SwiperSlide>;
        $[22] = itemClassName;
        $[23] = t16;
      } else {
        t16 = $[23];
      }
      t15 = children.map(t16);
      $[19] = children;
      $[20] = itemClassName;
      $[21] = t15;
    } else {
      t15 = $[21];
    }
    let t16;
    if ($[24] !== mobileItemsPerView || $[25] !== t14 || $[26] !== t15) {
      t16 = <Swiper modules={t10} spaceBetween={8} slidesPerView={mobileItemsPerView} freeMode={t11} onSwiper={t12} breakpoints={t14} className="w-full !px-3 md:!px-0">{t15}</Swiper>;
      $[24] = mobileItemsPerView;
      $[25] = t14;
      $[26] = t15;
      $[27] = t16;
    } else {
      t16 = $[27];
    }
    t8 = <div className={t9}>{t16}{showArrows && <><button onClick={handlePrevClick} className={cn("hidden md:block absolute left-0 z-10 border-none    transition-all duration-200", buttonSizeClasses[navigationSize], buttonThemeClasses[navigationTheme])} style={{
          top: "calc(50% * 0.5)"
        }} aria-label="Previous slide"><NextImage src={ChevronLeftCarousel} alt="Previous" className="w-full h-full" /></button><button onClick={handleNextClick} className={cn("hidden md:block absolute right-0 z-10 border-none  transition-all duration-200 rotate-180", buttonSizeClasses[navigationSize], buttonThemeClasses[navigationTheme])} style={{
          top: "calc(50% * 0.5)"
        }} aria-label="Next slide"><NextImage src={ChevronLeftCarousel} alt="Next" className="w-full h-full " /></button></>}</div>;
    $[2] = children;
    $[3] = className;
    $[4] = desktopItemsPerView;
    $[5] = itemClassName;
    $[6] = mobileItemsPerView;
    $[7] = navigationSize;
    $[8] = navigationTheme;
    $[9] = showArrows;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  return t8;
}